import React from "react";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { ActionField } from "common/Components/TableFields/TableFields";
import { getSignedS3DownlaodURL } from "ui/pages/transactions/AllTransaction/components/InitiateDisputeModal/utils/InitiateDisputeModal.utils";
import { FIELD_DATA } from "../../../constants/disputes.constant";

export const DisputeDocumentsLinksModal = ({ open, setOpen, record }) => {
  return (
    <ExlyModal
      title="Uploaded Documents View"
      header="Uploaded Documents View"
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      customFooter={<></>}
    >
      <div className="tw-mt-[10px] tw-mb-[10px] tw-grid tw-text-center tw-py-[10px] tw-px-[10px]">
        {record[FIELD_DATA.documents].map((document, index) => {
          return (
            <div
              key={`${record?.id}-${index + 1}`}
              className="tw-flex tw-mb-[10px] tw-gap-[10px] max-[767px]:tw-justify-between"
            >
              <div className="tw-flex tw-gap-[10px]">
                <span className="tw-w-[20px]">{index + 1}.</span>
                <span className="tw-w-[200px] tw-text-left tw-ml-[10px] tw-truncate">
                  {document.file_name}
                </span>
              </div>
              <ActionField
                label="Open"
                record={document}
                onClick={({ record }) => getSignedS3DownlaodURL(record, "url")}
                className="tw-mr-[10px] tw-w-[100px] tw-flex min-[768px]:tw-justify-center max-[767px]:tw-justify-end tw-items-center"
              />
            </div>
          );
        })}
      </div>
    </ExlyModal>
  );
};
